export const EMI_PAGE_TITLE = "Credit Card EMI";

export const EMI_ERROR = {
    TITLE: "Oops! Something went wrong.",
    MESSAGE: "To see payment options, please try to reload the page.",
    ACTION: "Go Back",
};

export const TENANT = "DASH";
